module.exports = __webpack_public_path__ + "img/block7-img.b91bdd89.svg";